var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.646894 0.646039C0.693339 0.599476 0.748515 0.562533 0.80926 0.537327C0.870005 0.51212 0.935126 0.499146 1.00089 0.499146C1.06666 0.499146 1.13178 0.51212 1.19253 0.537327C1.25327 0.562533 1.30845 0.599476 1.35489 0.646039L7.35489 6.64604C7.40146 6.69248 7.4384 6.74766 7.46361 6.80841C7.48881 6.86915 7.50179 6.93427 7.50179 7.00004C7.50179 7.06581 7.48881 7.13093 7.46361 7.19167C7.4384 7.25242 7.40146 7.30759 7.35489 7.35404L1.35489 13.354C1.26101 13.4479 1.13367 13.5007 1.00089 13.5007C0.868118 13.5007 0.74078 13.4479 0.646894 13.354C0.553007 13.2602 0.500262 13.1328 0.500262 13C0.500262 12.8673 0.553007 12.7399 0.646894 12.646L6.29389 7.00004L0.646894 1.35404C0.60033 1.30759 0.563387 1.25242 0.538181 1.19167C0.512974 1.13093 0.5 1.06581 0.5 1.00004C0.5 0.934272 0.512974 0.869151 0.538181 0.808406C0.563387 0.747661 0.60033 0.692485 0.646894 0.646039Z",
    fill: "#8D9AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.6307efa49be141e9389b6d15a3619228.svg";
export { ForwardRef as ReactComponent };